import script from "./infoCourse.vue?vue&type=script&setup=true&lang=js"
export * from "./infoCourse.vue?vue&type=script&setup=true&lang=js"

import "./infoCourse.vue?vue&type=style&index=0&id=dd93c3ec&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd93c3ec"]])

export default __exports__